export var ICON_PREFIX = 'acudicon';
export var ICON_PREFIX_DEPRECATED = 'acuicon';
export var DEFAULT_WIDTH = '1em';
